class NotifyMeApp extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.custom-restock-button');
    this.productContent = this.querySelector('.notify-me-content--product-info');
    this.privacyContent = this.querySelector('.notify-me-content--privacy');
    this.bottomContent = this.querySelector('.notify-me-content--bottom');
    this.closeSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="9.192" height="9.192" viewBox="0 0 9.192 9.192"><g transform="translate(4.596 -3.889) rotate(45)"><line y2="12" transform="translate(6)" fill="none" stroke="#1a1818" stroke-width="1"/><line y2="12" transform="translate(12 6) rotate(90)" fill="none" stroke="#1a1818" stroke-width="1"/></g></svg>`;
    this.checkboxPrivacy = this.querySelector('#input-privacy-custom');
    this.currentSizeElement = document.querySelector('[data-sizecontent]');
    this.restockWrapper = null;
    this.lastVariantId = null;

    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);

    if (this.button) {
      this.button.addEventListener('click', this.handleButtonClick);
    }
  }

  connectedCallback() {
    if (!this.unsubVariantChange) {
      this.unsubVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
    }

    // Read the initially selected variant from the theme's <variant-selects>
    // const selected = document.querySelector('variant-selects [data-selected-variant]');
    // if (selected) {
    //   try {
    //     const v = JSON.parse(selected.innerHTML);
    //     this.setVariantId(v?.id);
    //   } 
    //   catch {
    //     console.error('[NotifyMeApp] Failed to parse selected variant JSON:', err, { raw: selected.innerHTML });
    //   }
    // }
    // }
    const selectedVariantId = this.dataset.selectedVariantId;
    if (selectedVariantId) {
      try {
        this.setVariantId(selectedVariantId);
      } 
      catch {
        console.error('[NotifyMeApp] Failed to get selected variant from data-selected-variant-id:', err, this);
      }
    }

    // Auto-open notify-me overlay if arriving from wishlist with ?notify=true
    this.autoOpenFromWishlist();
  }

  /**
   * If URL contains #notify, auto-trigger the notify-me button click
   * with retry logic to wait for the ReStock Alerts app to be ready.
   */
  autoOpenFromWishlist() {
    if (window.location.hash !== '#notify') return;

    // Clean up hash immediately without reload
    window.history.replaceState({}, '', window.location.pathname + window.location.search);

    const maxAttempts = 10;
    const interval = 400;
    let attempts = 0;

    const tryClick = () => {
      attempts++;

      if (!this.button) {
        if (attempts < maxAttempts) {
          setTimeout(tryClick, interval);
        }
        return;
      }

      this.button.click();

      // Check if modal appears, retry if not
      setTimeout(() => {
        const modal = document.querySelector('.restock-alerts-modal-wrapper');
        if (!modal && attempts < maxAttempts) {
          setTimeout(tryClick, interval);
        }
      }, 800);
    };

    // Start quickly
    setTimeout(tryClick, 300);
  }

  /* disconnectedCallback() {
    // Unsubscribe from pub/sub when the element is removed from the DOM
    this.unsubVariantChange?.();
  } */

  setVariantId(id) {
    if (!id) return;
    this.lastVariantId = id;

    window._ReStockConfig = window._ReStockConfig || {};
    window._ReStockConfig.product = window._ReStockConfig.product || {};
    window._ReStockConfig.product.selected_or_first_available_variant_id = parseInt(id);

    this.syncModalVariant();
  }

  onVariantChange({ data }) {
    this.setVariantId(data?.variant?.id);
  }

  handleButtonClick() {
    const observer = new MutationObserver((mutations) => {
      for (const { addedNodes } of mutations) {
        for (const node of addedNodes) {
          if (node.nodeType === 1) {
            // Check if the node is or contains the target element
            if (node.classList?.contains('restock-alerts-modal-wrapper')) {
              this.restockWrapper = node;
            } else {
              this.restockWrapper = node.querySelector?.('.restock-alerts-modal-wrapper') || this.restockWrapper;
            }
    
            if (this.restockWrapper) {
              //console.log('Found and saved:', this.restockWrapper);
              observer.disconnect(); // Remove if you want to watch continuously
              this.customizePopup(this.restockWrapper);

              this.syncModalVariant();
              break;
            }
          }
        }
        if (this.restockWrapper) break; // Exit early if found
      }
    });
    
    observer.observe(document.body, { childList: true, subtree: true });
  }

  syncModalVariant() {
    if (!this.restockWrapper || !this.lastVariantId) return;

    const inputs = this.restockWrapper.querySelectorAll(
      'input[name="variant"], input[name="variant_id"], input[data-variant-input]'
    );
    inputs.forEach((i) => (i.value = String(this.lastVariantId)));

    this.restockWrapper.setAttribute('data-variant-id', String(this.lastVariantId));
  }

  customizePopup(wrapper) {
    let restockClose = wrapper.querySelector('.restock-alerts-modal-close-btn');
    let restockModalBox = wrapper.querySelector('.restock-alerts-modal-box');
    let restockForm = wrapper.querySelector('.restock-alerts-form');
    let restokFormTitle = wrapper.querySelector('.restock-alerts-form-title');
    let restockLowerSection = wrapper.querySelector('.modalBoxLowerSectionStyle');
    let restockSubmitButton = wrapper.querySelector('.restock-alerts-submit-button');
    
    // If you need to have the required checkbox 
    // const isChecked = this.checkboxPrivacy.checked;
    // if (isChecked) {
    //   restockSubmitButton.removeAttribute('disabled');
    // } else {
    //   restockSubmitButton.setAttribute('disabled', '');
    // }

    if (restockModalBox) {
      restockModalBox.classList.add('restock-popup-open');
    }

    if (this.closeSvg && restockClose) {
      const encoded = `data:image/svg+xml,${encodeURIComponent(this.closeSvg)}`;
      restockClose.setAttribute('src', encoded);
    }

    if (this.productContent && restokFormTitle) {
      restockForm.insertBefore(this.productContent, restokFormTitle.nextSibling);
      this.productContent.classList.remove('tw-hidden');
    }

    if (this.privacyContent && restockSubmitButton) {
      restockLowerSection.insertBefore(this.privacyContent, restockSubmitButton);
      this.privacyContent.classList.remove('tw-hidden');
    }

    if (this.bottomContent && restockSubmitButton) {
      restockLowerSection.insertBefore(this.bottomContent, restockSubmitButton.nextSibling);
      this.bottomContent.classList.remove('tw-hidden');
    }
    
    /* Change size shown on modal */
    let sizeValue = wrapper.querySelector('.size-js');
    if (this.currentSizeElement && sizeValue.innerHTML.trim() != this.currentSizeElement.innerHTML.trim()) {
      sizeValue.innerHTML =  this.currentSizeElement.innerHTML.trim();
    } 
  }
 
  handleCheckboxChange() {    
    const isChecked = this.checkboxPrivacy.checked;
    if (isChecked) {
      this.restockWrapper.querySelector('.restock-alerts-submit-button').removeAttribute('disabled');
    } else {
      this.restockWrapper.querySelector('.restock-alerts-submit-button').setAttribute('disabled', '');
    }
  }
  
}

customElements.define('notify-me-app', NotifyMeApp);

// Fallback: if #notify is in URL but <notify-me-app> is not in the DOM
// (e.g. pdp_status is not 'notify-me'), try to click the restock button directly
(function notifyMeFallback() {
  if (window.location.hash !== '#notify') return;

  const checkElement = () => {
    const app = document.querySelector('notify-me-app');
    if (app) return; // Component exists, let it handle

    const restockBtn = document.querySelector('[id^="restock-"]');
    if (restockBtn) {
      window.history.replaceState({}, '', window.location.pathname + window.location.search);
      restockBtn.click();
    }
  };

  if (document.readyState === 'complete') {
    setTimeout(checkElement, 500);
  } else {
    window.addEventListener('load', () => setTimeout(checkElement, 500));
  }
})();
